var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 374,
    viewBox: "0 0 576 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.844 0.409223C290.271 -4.45395 317.095 35.479 354.858 43.2746C413.2 55.3188 485.235 24.8176 530.997 58.0377C573.595 88.9608 588.15 152.37 565.134 195.92C540.405 242.713 458.133 240.633 415.425 276.718C387.905 299.971 397.861 346.231 365.612 364.501C333.404 382.747 290.47 369.027 251.844 369.39C212.759 369.757 174.791 373.866 136.624 366.651C87.443 357.355 33.9832 351.392 -2.15626 321.379C-41.3653 288.816 -70.3347 242.655 -68.9526 195.92C-67.5755 149.357 -40.6475 99.2526 5.15732 74.0742C50.8273 48.9699 113.789 82.6013 165.041 67.2965C202.443 56.1274 212.654 5.36873 251.844 0.409223Z",
    fill: "#132F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdVector);
export default __webpack_public_path__ + "static/media/ThirdVector.0c90a4ae2b852a836bf01f78a62e2c53.svg";
export { ForwardRef as ReactComponent };